import { Component, OnInit, Input, Output, EventEmitter, DoCheck } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Form } from 'app/shared/form';
import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { QuotaMovementsBatch } from 'app/_models/quota-movements-batch';
import { QuotaService } from 'app/_services/quota.service';
import { QuotaItem } from 'app/_models/quota-item';
import { BatchLine } from 'app/_models/batch-line';
import { BatchLineService } from 'app/_services/batch-line.service';
import { QuotaMovementsBatchService } from 'app/_services/quota-movements-batch.service';
import { Model } from 'app/_models/model';
import { Stock } from 'app/_models/stock';
import { Quota } from 'app/_models/quota';

@Component({
  selector: 'app-quota-transfer-form',
  templateUrl: './quota-transfer-form.component.html',
  styleUrls: ['./quota-transfer-form.component.css'],
  providers: [BatchLineService, QuotaMovementsBatchService],
})
export class QuotaTransferFormComponent extends Form implements OnInit, DoCheck {
  @Input() protected batch: QuotaMovementsBatch;
  @Output() callback = new EventEmitter<BatchLine>();

  public currentYear: string = Quota.getYears()[0];
  public loadingQuotaFlag = false;
  protected instance: BatchLine = new BatchLine({ target_mode: 'internal' });
  protected targetModes: any[];

  protected sources = {
    transfer: [
      { mode: 'origin', quotas: 'quotas' },
      { mode: 'destination', quotas: 'filteredQuotas' },
    ],
    reception: [
      { mode: 'destination', quotas: 'quotas' },
      { mode: 'origin', quotas: 'filteredQuotas' },
    ],
  };

  protected sourceQuotas = {
    quotas: [],
    filteredQuotas: [],
    loadingFlag: false,
  };
  private previousBatch: QuotaMovementsBatch = new QuotaMovementsBatch();

  constructor(
    private fb: FormBuilder,
    private quotaService: QuotaService,
    private batchLineService: BatchLineService,
    private quotaMovementsBatchService: QuotaMovementsBatchService,
    protected route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.form = fb.group({
      target_mode: '',
      external_alias: '',
      external_code: '',
      quota_origin: '',
      quota_destination: '',
      amount: '',
    });
  }

  public ngOnInit() {
    this.currentYear = this.batch.year || Quota.getYears()[0];
    this.setFormMode('create');
    this.getQuotas();
    this.getTargetModes();
  }

  public ngDoCheck() {
    if (!this.batch.equals(this.previousBatch)) {
      if (this.batch.mode === 'reception') {
        this.instance.target_mode = 'external_ship';
      } else {
        this.instance.target_mode = 'internal';
      }
      this.previousBatch = new QuotaMovementsBatch(this.batch);
    }
  }

  public setCurrentYear(year: string) {
    this.currentYear = year;
  }

  public getQuotas() {
    this.loadingQuotaFlag = true;
    this.sourceQuotas.quotas = [];
    this.sourceQuotas.filteredQuotas = [];
    this.quotaService.list(1, 10000, `year=${this.currentYear}`, '').subscribe(
      (response) => {
        this.loadingQuotaFlag = false;
        this.sourceQuotas.quotas = this.parseQuotas(response.results);
      },
      (error) => {
        this.loadingQuotaFlag = false;
        this.httpErrorHandler.handleHttpError(error);
      }
    );
  }

  private getFilteredQuotas() {
    this.sourceQuotas.filteredQuotas = [];
    this.sourceQuotas.loadingFlag = true;
    this.quotaService.list(1, 10000, `year=${this.currentYear}`, '').subscribe(
      (response) => {
        this.sourceQuotas.loadingFlag = false;
        this.sourceQuotas.filteredQuotas = this.parseQuotas(response.results);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  public filterQuotas(sourceQuota) {
    if (sourceQuota) {
      this.getFilteredQuotas();
    } else {
      this.sourceQuotas.filteredQuotas = [];
    }
  }

  private parseQuotas(results: any[]) {
    const collection = [];
    const qh = new QuotaItem();
    for (const key in results) {
      if (results.hasOwnProperty(key)) {
        collection.push(qh.apiMap(results[key]));
      }
    }
    return collection;
  }

  public getTargetModes() {
    this.batchLineService.getOptions().subscribe(
      (data) => {
        this.targetModes = Model.generateCollectionFromApi(data['actions']['POST']['target_mode']['choices']);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  public onSubmit() {
    this.form.reset();
    this.resetNonFieldErrors();
    if (this.batch.id) {
      this.addBatchLine();
    } else {
      this.createBatchLine();
    }
  }

  public createBatchLine() {
    this.batchLineService.create(this._serialize()).subscribe(
      (line) => this.onCreate(line),
      (error) => this.handleError(error)
    );
  }

  public addBatchLine() {
    this.quotaMovementsBatchService.add_line(this.batch.id, this._serialize()).subscribe(
      (line) => this.onCreate(line),
      (error) => {
        this.handleError(error);
      }
    );
  }

  public onCreate(line) {
    this.callback.emit(new BatchLine().apiMap(line));
    // reset form
    this.instance = new BatchLine();
  }

  private _serialize() {
    const record = this.instance.serialize();
    const batch_record = this.batch.serialize();
    record['date'] = batch_record['date'];
    record['mode'] = batch_record['mode'];

    return record;
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-batchs/components/quota-transfer-form/quota-transfer-form.component.ts